import React from "react";
import { Link } from "react-router-dom";

import type { Breadcrumb } from "veneer/Breadcrumbs";
import type { LinkProps } from "veneer/Link";

const BreadcrumbLink = ({ children, dataTestId, path, ...rest }: LinkProps) => {
  return (
    <Link data-testid={dataTestId} to={path} {...rest}>
      {children}
    </Link>
  );
};

type BreadcrumbItem = {
  key?: string;
  label: string;
  target: string;
  dataTestId?: string;
};

export function getBreadcrumbs(
  breadcrumbs: ReadonlyArray<BreadcrumbItem>,
): Breadcrumb[] {
  const breadcrumbArray: Breadcrumb[] = [];
  breadcrumbs.forEach((breadcrumb, index) => {
    const key = breadcrumb.key || `breadcrumb-${index}`;

    breadcrumbArray.push(
      <BreadcrumbLink
        dataTestId={breadcrumb.dataTestId}
        key={key}
        path={breadcrumb.target}
      >
        {breadcrumb.label}
      </BreadcrumbLink>,
    );
  });

  return breadcrumbArray;
}
